function ordinalSuffix(day) {
  const v = day % 100;
  if (v >= 11 && v <= 13) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

export function formatDateWithOrdinal(dateStr) {
  const parsed = Date.parse(dateStr);
  if (!Number.isNaN(parsed)) {
    const d = new Date(parsed);
    const day = d.getDate();
    const month = d.toLocaleString('en-US', { month: 'long' });
    const year = d.getFullYear();
    return `${month} ${day}${ordinalSuffix(day)}, ${year}`;
  }
  return String(dateStr);
}

export function formatDateForTooltip(dateStr) {
  const parsed = Date.parse(String(dateStr));
  if (!Number.isNaN(parsed)) {
    return new Date(parsed).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
  return String(dateStr);
}

